import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    contentContainer: 'relative w-full flex md:(pl-5 pointer-events-none) pb-6'
  },
} satisfies CMSConfig['hero']
